export const buildTree = (flatData: any[]) => {
    if (!flatData?.length) return [];

    let minLevel = 100;
    let maxLevel = 0;

    flatData?.forEach(item => {
        const lvl = item.Nivel || 1;
        if (lvl < minLevel) minLevel = lvl;
        if (lvl > maxLevel) maxLevel = lvl;
    });

    const orderedLevels: Record<number, any[]> = {};

    flatData?.forEach(item => {
        const lvl = item.Nivel || 1;
        if (!orderedLevels[lvl]) orderedLevels[lvl] = [];
        orderedLevels[lvl].push({ ...item, items: [], Nivel: lvl });
    });

    const findChildren = (level: number, parentId: string | null): any[] => {
        if (level > maxLevel) return [];

        const currentLevelItems = orderedLevels[level] || [];

        const children = currentLevelItems.filter(item => {
            const itemParentId = item.PhantomParentId ?? item.CodPadre ?? null;

            if (parentId === null) {
                return true;
            }
            return itemParentId === parentId;
        });

        return children.map(item => {
            const nextLevel = level + 1;
            const myId = item.CodProyecto || item.CodClasificacion || item.CodInsumo;

            const subItems = (myId && nextLevel <= maxLevel) ? findChildren(nextLevel, myId) : [];

            return { ...item, items: subItems };
        });
    };

    return findChildren(minLevel, null);
};

export const getTypeCode = (typeAbbr: string) => {
    switch (typeAbbr.toLowerCase()) {
        case 'pc': return '01';
        case 'de': return '04';
        case 'fr': return '05';
        default: return '01';
    }
};
